export const features = [
  {
    title: "CERMATI",
    desc: "Selamat datang di fitur Cermati! Di sini Anda dapat mempelajari informasi terkait perencanaan pembelajaran secara mendalam.",
    icon: "/illustration/Gambar-CERMATI.png",
    className: "cermati",
  },
  {
    title: "EKSPLORASI",
    desc: "Jelajahi berbagai contoh video digital storytelling berbasis budaya dan temukan inspirasi baru.",
    icon: "/illustration/Gambar-EKSPLORASI.png",
    className: "eksplorasi",
  },
  {
    title: "RANCANG",
    desc: "Rancang strategi pembelajaran digital yang inovatif dan sesuai kebutuhan peserta didik.",
    icon: "/illustration/Gambar-RANCANG.png",
    className: "rancang",
  },
  {
    title: "DESAIN",
    desc: "Desain media dan materi pembelajaran digital yang menarik dan interaktif.",
    icon: "/illustration/Gambar-DESAIN.png",
    className: "desain",
  },
  {
    title: "ASAH",
    desc: "Asah keterampilan berpikir kritis dan kreativitas melalui aktivitas pembelajaran interaktif.",
    icon: "/illustration/Gambar-ASAH.png",
    className: "asah",
  },
  {
    title: "SEBAR",
    desc: "Sebarkan karya dan ide pembelajaran Anda kepada komunitas pendidikan untuk dampak yang lebih luas.",
    icon: "/illustration/Gambar-SEBAR.png",
    className: "sebar",
  },
];